import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';

const GlossaryHeader = ({ 
  searchTerm, 
  onSearchChange, 
  onAddNew, 
  totalWords, 
  completedWords 
}) => {
  const completionPercentage = totalWords > 0 
    ? Math.round((completedWords / totalWords) * 100) 
    : 0;

  return (
    <div className="bg-card border-b border-border">
      <div className="max-w-screen-2xl mx-auto px-6 py-6">
        <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4 mb-6">
          <div>
            <h1 className="text-3xl font-bold text-foreground mb-2">Glossary Management</h1>
            <p className="text-muted-foreground">
              Manage archaic English word definitions and pronunciation audio
            </p>
          </div>
          <Button 
            variant="default" 
            iconName="Plus" 
            iconPosition="left"
            onClick={onAddNew}
          >
            Add New Word
          </Button>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
          <div className="bg-background border border-border rounded-lg p-4">
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center">
                <Icon name="BookText" size={24} className="text-primary" />
              </div>
              <div>
                <p className="text-sm text-muted-foreground">Total Words</p>
                <p className="text-2xl font-bold text-foreground">{totalWords}</p>
              </div>
            </div>
          </div>

          <div className="bg-background border border-border rounded-lg p-4">
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 rounded-lg bg-success/10 flex items-center justify-center">
                <Icon name="CheckCircle" size={24} className="text-success" />
              </div>
              <div>
                <p className="text-sm text-muted-foreground">Completed</p>
                <p className="text-2xl font-bold text-foreground">{completedWords}</p>
              </div>
            </div>
          </div>

          <div className="bg-background border border-border rounded-lg p-4">
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 rounded-lg bg-accent/10 flex items-center justify-center">
                <Icon name="TrendingUp" size={24} className="text-accent" />
              </div>
              <div>
                <p className="text-sm text-muted-foreground">Completion Rate</p>
                <p className="text-2xl font-bold text-foreground">{completionPercentage}%</p>
              </div>
            </div>
          </div>
        </div>

        <div className="relative">
          <Input
            type="search"
            placeholder="Search words, definitions, or plays..."
            value={searchTerm}
            onChange={(e) => onSearchChange(e?.target?.value)}
            className="pl-12"
          />
          <Icon 
            name="Search" 
            size={20} 
            className="absolute left-4 top-1/2 -translate-y-1/2 text-muted-foreground pointer-events-none" 
          />
        </div>
      </div>
    </div>
  );
};

export default GlossaryHeader;